import { render, staticRenderFns } from "./ItemStoreSpecial.vue?vue&type=template&id=54c73207&"
import script from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"
export * from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c73207')) {
      api.createRecord('54c73207', component.options)
    } else {
      api.reload('54c73207', component.options)
    }
    module.hot.accept("./ItemStoreSpecial.vue?vue&type=template&id=54c73207&", function () {
      api.rerender('54c73207', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/casa/ItemStoreSpecial.vue"
export default component.exports